module.exports = __webpack_public_path__ + "img/96.5b7842f5.jpg";